export { oksjonid };

let refreshAuction;

const oksjonid = () => {
    if (MODULE_NAME === "oksjonid") {
        if (typeof oksjonidSetAuctionLinkIt !== 'undefined') {
            MO.setAuctionLink(oksjonidSetAuctionLinkIt);
            MO.setRefreshItems({
                "offer-history": 1
            });
    
            refreshAuction = function() {
                $("#offer-history").find(".item-loader").show();
                $.ajax({
                    url: oksjonidRefreshAuctionLinkIt,
                    dataType: "json",
                    success: function (result) {
                        $("#offer-history").find(".item-loader").hide();
                        $(".timer").html(result["avalduse_aeg_f"]);
                        $(".lopp").html(result["lopp_f"]);
                        $(".lopuni").html(result["lopuni_f"]);
                        $("#offer-history-wrapper").html(result["ajalugu"]);
    
                        setTimeout(refreshAuction, 2000);
                    }
                });
            }
    
            //refreshAuction();
        }
        if (typeof oksjonidInfo_originLat !== 'undefined' && typeof oksjonidInfo_originLng !== 'undefined') {
            window.addEventListener("load", function () {
                var info_origin = new google.maps.LatLng(oksjonidInfo_originLat, oksjonidInfo_originLng);
                var myOptions = {
                    zoom: 9,
                    center: info_origin,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    scrollwheel: true
                }
                var info_map = new google.maps.Map(document.getElementById("map_canvas_info"), myOptions);
                var marker = new google.maps.Marker({
                    position: info_origin,
                    map: info_map,
                    title: "Oksjoniobjekti asukoht"
                });
            });
        }
    }
}